export const SHORT = 'SHORT'
export const LONG = 'LONG'
